import React from "react";
import { Heart, MessageCircle, Phone } from "lucide-react";

export default function TeacherDetailContactActions({
  onOpenCheerModal,
  teacher,
  theme,
  userProfile,
}) {
  const currentUserId = userProfile?.uid || userProfile?.id;
  const isMyLinkedProfile =
    currentUserId &&
    teacher.linkedUserId &&
    String(teacher.linkedUserId) === String(currentUserId);
  const canSendCheer = teacher.linkedUserId && !isMyLinkedProfile;

  return (
    <div className="grid grid-cols-3 gap-2 w-full mb-6">
      <a href={`tel:${teacher.phone}`} className={`py-3 rounded-2xl ${theme.bg} text-white font-bold text-sm flex items-center justify-center gap-1.5 shadow-lg ${theme.shadow}/20 hover:opacity-90 hover:scale-[0.98] active:scale-[0.95] transition-all duration-200`}>
        <Phone size={16} fill="currentColor" /> 전화
      </a>
      <a href={`sms:${teacher.phone}`} className="py-3 rounded-2xl bg-[#FFECA1] text-[#4A3B10] font-bold text-sm flex items-center justify-center gap-1.5 shadow-lg shadow-yellow-400/20 hover:bg-[#FFD54F] hover:scale-[0.98] active:scale-[0.95] transition-all duration-200">
        <MessageCircle size={16} /> 문자
      </a>
      <button
        onClick={() => teacher.linkedUserId && onOpenCheerModal && onOpenCheerModal(teacher)}
        disabled={!teacher.linkedUserId || isMyLinkedProfile}
        className={`py-3 rounded-2xl font-bold text-sm flex items-center justify-center gap-1.5 shadow-lg transition-all duration-200 ${canSendCheer
          ? "bg-gradient-to-r from-rose-400 to-pink-500 text-white shadow-rose-500/20 hover:opacity-90 hover:scale-[0.98] active:scale-[0.95]"
          : "bg-gray-100 text-gray-400 cursor-not-allowed shadow-none"
          }`}
        title={teacher.linkedUserId ? (isMyLinkedProfile ? "나에게는 격려를 보낼 수 없어요" : "격려 보내기") : "앱 계정 연결 필요"}
      >
        <Heart size={16} fill={canSendCheer ? "currentColor" : "none"} /> 격려
      </button>
    </div>
  );
}
